import { create } from 'zustand';

export interface ChatMessage {
  id: string;
  role: 'user' | 'bot' | 'error';
  text: string;
  timestamp: string;
  products?: any[]; // The extracted product data
}

interface AiChatState {
  messages: ChatMessage[];
  isLoading: boolean;
  isOpen: boolean;
  sessionId: string;
  hasShownWelcome: boolean;
  setIsOpen: (isOpen: boolean) => void;
  addMessage: (message: Omit<ChatMessage, 'id' | 'timestamp'>) => void;
  setLoading: (isLoading: boolean) => void;
  clearChat: () => void;
}

const generateSessionId = () => Math.random().toString(36).substring(2, 15);

export const useAiChatStore = create<AiChatState>((set) => ({
  messages: [],
  isLoading: false,
  isOpen: false,
  sessionId: generateSessionId(),
  hasShownWelcome: false,

  setIsOpen: (isOpen) => set({ isOpen, hasShownWelcome: true }),
  
  addMessage: (message) => set((state) => ({
    messages: [...state.messages, {
      ...message,
      id: Math.random().toString(36).substring(2, 9),
      timestamp: new Date().toISOString()
    }]
  })),

  setLoading: (isLoading) => set({ isLoading }),

  clearChat: () => set({
    messages: [],
    sessionId: generateSessionId(),
    isLoading: false
  })
}));
